import { createSlice } from '@reduxjs/toolkit'
import { downloadVendorOrderFile, getVendors, updateVendorBulk } from '../../apis'

export const supplyHeaderSlice = createSlice({
    name: 'supplyHeader',
    initialState: {
        isLoading: '',
        error: '',
        vendorsData: [],
        searchObject: {},
        vendorName: '',
        vendorId: '',
        pageStatus: '',
        pageComponent: '',
        downloadBulkVendorSuccess: false,
        uploadBulkVendorSuccess: false,
    },
    reducers: {
        setSearchObject: (state, action) => {
            state.searchObject = action.payload;
        },
        setVendorDetails: (state, action) => {
            state.vendorName = action.payload.name;
            state.vendorId = action.payload.id;
        },
        setPageStatus: (state, action) => {
            state.pageStatus = action.payload.status;
        },
        setPageComponent: (state, action) => {
            state.pageComponent = action.payload.status;
        },
        clear: (state, action) => {
            state[action.payload.key] = action.payload.value;
        }
        
    },
    extraReducers: (builder) => {
        builder.addCase(getVendors.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getVendors.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.vendorsData = action.payload.data
        })
        builder.addCase(getVendors.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })

        builder.addCase(downloadVendorOrderFile.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadVendorOrderFile.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.downloadBulkVendorSuccess = true
        })
        builder.addCase(downloadVendorOrderFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateVendorBulk.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(updateVendorBulk.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.uploadBulkVendorSuccess = true
        })
        builder.addCase(updateVendorBulk.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { setSearchObject, setVendorDetails, setPageStatus, setPageComponent, clear } = supplyHeaderSlice.actions

export default supplyHeaderSlice.reducer